module.exports = __webpack_public_path__ + "resources/icon_50_message.ee0fe430eb27e22a.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_message.png
// module id = 467
// module chunks = 0 1 2 3 4